export const PRICING_COMPARISON_COLUMN_WIDTH = 130;
